/** @jsxImportSource @emotion/react */
import 'swiper/swiper-bundle.min.css';

import dots from 'components/landing/images/dots.svg';
import { colors } from 'components/landing/ui';
import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import Slide from './slide';

const Slider = ({ currentReviewIndex, selectReview, reviews }) => {
  const [hideShadow, setHideShadow] = useState(false);

  const swiperRef = useRef();

  const handleStart = s => {
    selectReview(s.activeIndex);

    setHideShadow(true);
  };

  const handleEnd = () => {
    setHideShadow(false);
  };

  useEffect(() => {
    if (currentReviewIndex !== swiperRef.current.activeIndex) {
      swiperRef.current.slideTo(currentReviewIndex);
    }
  }, [currentReviewIndex]);

  const { avatarLarge } = reviews[currentReviewIndex];

  return (
    <div
      css={{
        overflow: 'hidden',
        position: 'relative',
        flexDirection: 'column',
        width: 'calc(100% + 30px)',
        marginLeft: -15,
        marginBottom: -10,
        '@media (min-width:768px)': { marginBottom: 0, width: '100%', marginLeft: 0 },
      }}
    >
      <div
        css={{
          width: '100%',
          justifyContent: 'center',
          zIndex: 2,
          paddingBottom: 80,
        }}
      >
        <img
          srcSet={avatarLarge}
          css={{
            width: '100%',
            maxWidth: 364,
            '@media (min-width:992px)': { maxWidth: 295, marginRight: 5 },
          }}
        />
      </div>
      <img
        src={dots}
        css={{
          position: 'absolute',
          display: 'none',
          zIndex: 1,
          right: 0,
          top: 45,
          '@media (min-width:992px)': { display: 'block' },
        }}
      />

      <div
        css={{
          position: 'absolute',
          zIndex: 3,
          bottom: 20,
          left: 0,
          width: '100%',
          paddingBottom: 30,
        }}
      >
        <Swiper
          css={{ width: '100%' }}
          slidesPerView={1.4}
          spaceBetween={30}
          centeredSlides
          breakpoints={{
            768: { slidesPerView: 1.6 },
            992: { slidesPerView: 1.6, slidesOffsetBefore: 10, centeredSlides: true },
          }}
          onSwiper={swiper => {
            swiperRef.current = swiper;

            swiper.on('slideChangeTransitionStart', handleStart);

            swiper.on('slideChangeTransitionEnd', handleEnd);

            swiper.on('touchStart', handleStart);

            swiper.on('touchEnd', handleEnd);
          }}
        >
          {reviews.map((r, i) => (
            <SwiperSlide key={i}>
              <Slide
                idx={i}
                active={currentReviewIndex === i}
                hideShadow={hideShadow}
                reviews={reviews}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        {currentReviewIndex !== 0 && (
          <div
            css={{
              position: 'absolute',
              width: 0,
              height: 'calc(100% + 10px)',
              background: colors.grayDark,
              left: 0,
              top: -20,
              zIndex: 1,
              '@media (min-width:768px)': { width: 2 },
            }}
          />
        )}
        {currentReviewIndex !== reviews.length - 1 && (
          <div
            css={{
              position: 'absolute',
              width: 0,
              height: 'calc(100% + 10px)',
              background: colors.grayDark,
              right: 0,
              top: -20,
              zIndex: 1,
              '@media (min-width:768px)': { width: 2 },
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Slider;
